import { Container } from './styles';

const Content = ({ children }) => {
  return <Container className="content">{children}</Container>;
};

export default Content;
